import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 30px;
  font-family: var(--font-family-base);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
`;

export const Title = styled.h2`
  margin: 0;
  padding-right: 28px;
  font-weight: 900;
  font-size: 20px;
  line-height: 26px;
  color: var(--black-dark);
`;

export const Subtext = styled.p`
  margin: 20px 0 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--light-gray-darker);
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

const modalButton = css`
  height: 36px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: var(--font-family-base);
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  white-space: nowrap;
`;

export const ContinueButton = styled.button`
  ${modalButton};
  flex: 165.5 1 0;
  background: var(--white);
  border: 1px solid var(--lilac);
  color: var(--black-dark);
`;

export const ZipButton = styled.button`
  ${modalButton};
  flex: 219 1 0;
  background: var(--black-dark);
  border: 1px solid var(--black-dark);
  color: var(--white);
`;
